import SvgIcons from "../../../shared/components/svgIcons";
import ChannelRollup from "../components/channel-rollup";

const isChannelRollupEmpty = true;

const rollupRoute = [
  {
    path: "channelrollup",
    element: <ChannelRollup />,
    link: "channelrollup",
    name: "Channelrollup",
    permission: "Channelrollup",
    icon: SvgIcons.PencilIcon,
    index: 8,
    hidden: isChannelRollupEmpty,
  },
];
export default rollupRoute;
